import { useEffect, useState } from 'react';
import RegisterFAComponent from '../../components/financial-asset/RegisterFAComponent';
import {
  createFinancialAsset,
  getFinancialAssets,
  getMyAssetList,
} from '../../api/constlink';
import client from '../../api/client';

function RegisterFAContainer() {
  const [financialAsset, setFinancialAsset] = useState<any>();
  const [enterpriseId, setEnterpriseId] = useState<string>();
  const [isTokenSaved, setIsTokenSaved] = useState<boolean>(false);

  useEffect(() => {
    // @ts-ignore
    window.setEnterpriseId = (_enterpriseId: string) => {
      setEnterpriseId(_enterpriseId);
    };

    // @ts-ignore
    window.setToken = (token: string) => {
      localStorage.setItem(process.env.REACT_APP_AUTH_TOKEN_NAME!, token);
      setIsTokenSaved(true);
    };
  }, []);

  useEffect(() => {
    if (process.env.NODE_ENV === 'development') {
      client.defaults.baseURL = 'http://10.0.2.2:4001/v1';
    }

    (async () => {
      if (enterpriseId === undefined) {
        return;
      }
      if (isTokenSaved === false) {
        return;
      }

      setFinancialAsset(await getFinancialAssets(enterpriseId, false));
    })();

    // return () => {
    //   if (process.env.NODE_ENV === 'development') {
    //     client.defaults.baseURL = process.env.REACT_APP_API_ENDPOINT;
    //   }
    // };
  }, [enterpriseId, isTokenSaved]);

  const _createFinancialAsset = async (result: any[]) => {
    await createFinancialAsset({
      enterpriseId,
      type: 'business',
      data: [...result],
    });

    // @ts-ignore
    Print.postMessage('웹 --> 앱');
  };

  const _getMyAssetList = async (data: any) => {
    const fa = await getMyAssetList({
      enterpriseId,
      data: {
        type: 'business',
        data,
      },
    });
    return fa;
  };

  return (
    <>
      {financialAsset && (
        <RegisterFAComponent
          existedFAList={financialAsset.data}
          _getMyAssetList={_getMyAssetList}
          _createFinancialAsset={_createFinancialAsset}
        />
      )}
    </>
  );
}

export default RegisterFAContainer;
